export const MODEL_TYPES = {
  TOOL: 'TOOL',
  SCALING: 'SCALING',
} as const;

export type ModelType = typeof MODEL_TYPES[keyof typeof MODEL_TYPES];
